module.exports = __webpack_public_path__ + "img/italians-DE.029ea442.png";